export default __webpack_public_path__ + "static/media/prueba.82f9323a.png";